import Dialog from "@stimulus-components/dialog"

export default class extends Dialog {
  static values = {
    open: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    }
  }

  open() {
    if (this.modalValue) {
      this.dialogTarget.showModal();
    } else {
      this.dialogTarget.open();
    }
  }
}